import React from 'react';
import SMConst from 'lib/SMConst.js';
import SMMapHelper from 'components/helpers/SMMapHelper.js';
import SMUSettingEditBaseFragment from './SMUSettingEditBaseFragment';
import SMFormFieldTitle from 'components/dashboard/form/SMFormFieldTitle';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormTextFieldWithError from 'components/dashboard/form/SMFormTextFieldWithError';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMUserResource from 'resources/SMUserResource';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMMasterResource from 'resources/SMMasterResource';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMUSettingEditContactFragmentView extends SMUSettingEditBaseFragment {

  constructor(props) {
    super(props);

    this.geocoder = null;
    this.formRequest = null;
    this.state = {
      user: this.props.user,
      contact: this.props.user.contact ? this.props.user.contact.attributes : {},
      isCurrent : this.isCurrent(this.props),
      industries: [],
      areas: [],
      jobs: [],
      errors: [],
    };
  }

  componentDidMount() {
    if (this.isCurrent(this.props)) SMAppHelper.setTitle(I18n.t('dashboard.label_000007'));

    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();

    SMMasterResource.getLargeAreas(1, (areas, error, xhr)=>{
      this.setState({ areas: areas });
    });

    SMMasterResource.getJobs((jobs, error, xhr)=>{
      this.setState({ jobs: jobs });
    });

    SMMasterResource.getIndustries((industries, error, xhr)=>{
      this.setState({ industries: industries });
    });

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
    });
  }

  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }

  getContactAttribute(name){
    return name.match(/^contact\[(.+)]/)[1];
  }

  textFieldDidEndEditing(e){
    const currentTarget = e.currentTarget;
    const name = currentTarget.name;
    const value = currentTarget.value;

    if (name === 'contact[postal_code]' && this.state.user.time_zone === 'Asia/Tokyo') {
      if (!this.geocoder) this.geocoder = new google.maps.Geocoder();

      this.geocoder.geocode({address: value}, (results, status) => {
        const address = SMMapHelper.getAddress(results, status);
        if (!address) return;

        const contact = this.state.contact;
        for (let i = 0; i < this.state.areas.length; i++) {
          let area = this.state.areas[i];
          if (area.name_text === address.prefecture) {
            contact.state = area.name;
            break;
          }
        }
        contact.city = address.city;
        contact.address_1 = address.address_1;
        contact.postal_code = value;

        this.setState({contact: contact});
      });
    } else {
      this.setState(function(previousState, currentProps) {
        let attribute = this.getContactAttribute(currentTarget.name);
        let newContact = Object.assign({}, previousState.contact);
        newContact[attribute] = currentTarget.value;
        return{
          contact: newContact,
        };
      });
    }
  }

  selectBoxDidChangeValue(e){
    let currentTarget = e.currentTarget;
    this.setState(function(previousState, currentProps) {
      let attribute = this.getContactAttribute(currentTarget.name);
      previousState.contact[attribute] = currentTarget.value;
      return{
        contact: previousState.contact,
      };
    });
  }

  checkBoxDidChangeValue(e){
    let currentTarget = e.currentTarget;
    this.setState(function(previousState, currentProps) {
      if (currentTarget.name == 'contact[is_corp]') {
        previousState.contact.is_corp = currentTarget.checked;
      }

      return{
        contact: previousState.contact,
      };
    });
  }

  formDidSubmit(e){
    e.preventDefault();

    let formData = new FormData(e.currentTarget);
    if (this.formRequest) this.formRequest.abort();
    this.formRequest = SMUserResource.updateUser(formData, {}, (user, error, xhr)=>{
      this.formRequest = null;
      if (error) {
        this.setState({errors: xhr.responseJSON.errors});
        return;
      } else if (xhr.status == 200) {
        this.setState({
          contact: user.contact,
          errors: []
        });
        this.props.delegate.showSuccessMessage();
      }
    });
  }

  renderCorpInformation(){
    if (this.state.contact.is_corp) {
      return(
        <div>
          <SMFormFieldTitle title={I18n.t('dashboard.label_000043')} subTitle={I18n.t('dashboard.text_000005')} isRequired={true} />
          <SMFormTextFieldWithError
            name="contact[corp_name]"
            value={this.state.contact.corp_name}
            placeholderText={I18n.t('dashboard.label_000174')}
            errorText={SMFormatHelper.errorText('User', 'contact.corp_name', this.state.errors)}
            options={{className:'w400'}}
            delegate={this}
          />

          <SMFormFieldTitle title={I18n.t('dashboard.label_000175')} isRequired={false} />
          <SMFormTextFieldWithError
            name="contact[department]"
            value={this.state.contact.department}
            placeholderText={I18n.t('dashboard.label_000180')}
            errorText={SMFormatHelper.errorText('User', 'contact.department', this.state.errors)}
            options={{className:'w400'}}
            delegate={this}
          />
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    let industries = [],
        jobs = [],
        areas = [];

    for (let i=0; i < this.state.industries.length; i++) {
      industries.push({value: this.state.industries[i].name,
                      label: this.state.industries[i].name_text});
    }

    for (let i=0; i < this.state.jobs.length; i++) {
      jobs.push({value: this.state.jobs[i].name,
                      label: this.state.jobs[i].name_text});
    }

    for (let i = 0; i < this.state.areas.length; i++) {
      let area = this.state.areas[i];
      areas.push({value: area.name, label: area.name_text});
    }

    return(
      <div style={this.fragmentStyle()}>
        <form onSubmit={this.formDidSubmit.bind(this)}>
          <SMFormFieldTitle title={I18n.t('dashboard.label_000193')} subTitle={I18n.t('dashboard.text_000034')} isRequired={true} />
          <div className="form-box">
            <SMFormTextField name="contact[family_name]" value={this.state.contact.family_name} placeholderText={I18n.t('dashboard.label_000172')} options={{className:'w280 mr20'}} delegate={this} />
            <SMFormTextField name="contact[given_name]" value={this.state.contact.given_name} placeholderText={I18n.t('dashboard.label_000173')} options={{className:'w280 mr20'}} delegate={this} />
            <SMFormValidationMessage name="contact[family_name]" errorText={SMFormatHelper.errorText("User", "contact.family_name", this.state.errors)} />
            <SMFormValidationMessage name="contact[given_name]" errorText={SMFormatHelper.errorText("User", "contact.given_name", this.state.errors)} />
          </div>

          <SMFormFieldTitle title={I18n.t('dashboard.label_000096')} subTitle={I18n.t('dashboard.text_000059')} isRequired={true} />
          <SMFormTextFieldWithError
            name="contact[tel]"
            value={this.state.contact.tel}
            type="tel"
            errorText={SMFormatHelper.errorText('User', 'contact.tel', this.state.errors)}
            placeholderText="0312345678"
            options={{className:'w400'}}
            delegate={this}
          />

          <div className="w320 fl">
            <SMFormFieldTitle title={I18n.t('dashboard.label_000040')} isRequired={false} />
            <div className="form-box">
              <span className="form-select__inner">
                <label className="form-select">
                  <SMFormSelectBox name='contact[industry_id]' items={industries} selectedValue={this.state.contact.industry_id} delegate={this} options={{className:'w300'}} isRequired={false} />
                </label>
              </span>
            </div>
          </div>

          <SMFormFieldTitle title={I18n.t('dashboard.label_000041')} isRequired={false} />
          <div className="form-box">
            <span className="form-select__inner">
              <label className="form-select">
                <SMFormSelectBox name='contact[job_id]' items={jobs} selectedValue={this.state.contact.job_id} delegate={this} options={{className:'w300'}} isRequired={false} />
              </label>
            </span>
          </div>

          <SMFormFieldTitle title={I18n.t('dashboard.label_000042')} subTitle={I18n.t('dashboard.text_000004')} isRequired={true} />
          <div className="form-box">
            <input type='hidden' name='contact[is_corp]' value='0' />
            <input type="checkbox" id='form-checkbox01__01' name='contact[is_corp]' value='1' defaultChecked={this.state.contact.is_corp} onChange={this.checkBoxDidChangeValue.bind(this)} />
            <label htmlFor='form-checkbox01__01' className='form-checkbox'>{I18n.t('dashboard.label_000042')}</label>
          </div>

          <CSSTransitionGroup transitionName="js-list-fade-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
            {this.renderCorpInformation()}
          </CSSTransitionGroup>

          <SMFormFieldTitle title={I18n.t('dashboard.label_000176')} subTitle={I18n.t('dashboard.text_000035')} isRequired={true} />
          <SMFormTextFieldWithError
            name="contact[postal_code]"
            value={this.state.contact.postal_code}
            errorText={SMFormatHelper.errorText('User', 'contact.postal_code', this.state.errors)}
            placeholderText="1600023"
            options={{className:"w110"}}
            delegate={this}
          />

          <SMFormFieldTitle title={I18n.t('dashboard.label_000177')} isRequired={true} />
          <div className="form-box">
            <span className="form-select__inner mr5">
              <label className="form-select">
                <SMFormSelectBox name="contact[state]" items={areas} selectedValue={this.state.contact.state} delegate={this} />
              </label>
            </span>
            <SMFormTextField name="contact[city]" value={this.state.contact.city} placeholderText="新宿区" options={{className:"w300"}} delegate={this} />
            <SMFormValidationMessage name='contact[city]' errorText={SMFormatHelper.errorText('User', 'contact.city', this.state.errors)} />
          </div>

          <SMFormFieldTitle title={I18n.t('dashboard.label_000178')} isRequired={true} />
          <SMFormTextFieldWithError
            name="contact[address_1]"
            value={this.state.contact.address_1}
            errorText={SMFormatHelper.errorText('User', 'contact.address_1', this.state.errors)}
            placeholderText="西新宿6-15-1"
            delegate={this}
          />

          <SMFormFieldTitle title={I18n.t('dashboard.label_000179')} isRequired={false} />
          <SMFormTextFieldWithError
            name="contact[address_2]"
            value={this.state.contact.address_2}
            errorText={SMFormatHelper.errorText('User', 'contact.address_2', this.state.errors)}
            placeholderText="ラ・トゥール新宿608号室"
            options={{className:'w400'}}
            delegate={this}
          />

          <input type='hidden' name='contact[id]' value={this.state.contact.id} />
          <input type='hidden' name='contact[user_id]' value={this.state.user.id} />

          <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
            <input className="button-green maincol-buttonarea__button" type="submit" value="保存" />
          </div>
        </form>
      </div>
    );
  }
}
export default SMUSettingEditContactFragmentView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/settings/fragments/SMUSettingEditContactFragmentView.jsx